export default __webpack_public_path__ + "9394a527d672db64847f331e01622f61.png";